<template>
  <div class="mt-5 w-full">
    <hr class="mb-5">
    <div class="flex justify-end gap-2">
      <Button @click="searchData" :disabled="search.processing" :unstyled="true"
        class="bg-white hover:bg-primary-50 text-blue-700 font-medium py-1 px-3 rounded-md border border-blue-200 hover:border-blue-300 transition-colors duration-150 disabled:opacity-60 disabled:cursor-not-allowed">
        {{ __('Find') }}
      </Button>
      <Button @click="cancelSearch" :disabled="search.processing" :unstyled="true"
        class="bg-white hover:bg-gray-200 text-gray-600 font-medium py-1 px-3 rounded-md border border-gray-200 hover:border-gray-300 transition-colors duration-150 disabled:opacity-60 disabled:cursor-not-allowed">
        {{ __('Cancel') }}
      </Button>
      <Button v-if="searchProps.data" @click="clearSearch" :disabled="search.processing" :unstyled="true"
        class="bg-white hover:bg-amber-50 text-amber-700 font-medium py-1 px-3 rounded-md border border-amber-200 hover:border-amber-300 transition-colors duration-150 disabled:opacity-60 disabled:cursor-not-allowed">
        {{ __('Clear') }}
      </Button>
    </div>
  </div>
</template>

<script setup>
import { watch } from 'vue'
import Button from 'primevue/button';
import { useForm } from '@inertiajs/vue3';
import { __, convertDate } from '@pages/Helper/utils.js'

//-----------------------------------------------------------------------------

const props = defineProps({
  searchProps: Object,
  search: Object,
})

const autoSearch = defineModel('autoSearch')

//-----------------------------------------------------------------------------

watch(() => autoSearch.value, (newValue, oldValue) => {
  if (newValue) {
    searchData()
  }
}, { deep: true, immediate: true })

// -----------------------------------------------------------------------------------------------------------

const searchData = () => {
  const sourceSearch = props.search
  for (let field in sourceSearch) {
    if (sourceSearch[field] instanceof Date) {
      sourceSearch[field] = convertDate(sourceSearch[field])
    }

    if (field === 'parent_id' && typeof sourceSearch[field] === 'object') {
      let tmp = []
      for (let elem in sourceSearch[field]) {
        tmp.push(parseInt(elem))
      }
      sourceSearch[field] = tmp
    }

    if (sourceSearch[field] === null) {
      delete sourceSearch[field]
    }

  }

  props.searchProps.clearSelection()
  useForm(props.searchProps).getLazyData({ page: 1, 'search': sourceSearch });
  props.searchProps.closeModal()
}

//-----------------------------------------------------------------------------

const clearSearch = () => {
  props.searchProps.clearSelection()
  useForm(props.searchProps).getLazyData({ page: 1, 'search': {} });
  props.searchProps.closeModal()
}

//-----------------------------------------------------------------------------

const cancelSearch = () => {
  props.searchProps.closeModal()
}

//-----------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
